<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <!-- data table -->
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs v-model="tab" background-color="#1B437C" dark>
                <v-tab>
                  รอรับของรางวัล
                </v-tab>
                <v-tab>
                  รับของรางวัล
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-row class="mb-4">
                        <v-col cols="12" md="5">
                          <v-select
                            v-model="selectedProduct"
                            :items="productList"
                            item-text="name"
                            item-value="rewardId"
                            label="สินค้าที่แลก"
                            clearable
                            outlined
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-menu
                            v-model="dateMenu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            hide-details
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="expiryDateRange1"
                                label="วันหมดอายุ (ช่วงเวลา)"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                clearable
                                @click:clear="clearDateFilter1"
                                v-bind="attrs"
                                v-on="on"
                                 hide-details
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="expiryDate1"
                              range
                              @input="formatDateRange1"
                              @change="dateMenu1 = false"
                               hide-details
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="2" class="d-flex align-center">
                          <v-btn
                            color="primary"
                            block
                            @click="filterData1"
                          >
                            <v-icon left>mdi-magnify</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="columns1"
                        :items="filteredDataItem1"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.point`]="{ item }">
                          {{ formatNumber(item.point) }}
                        </template>
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ format_dateNotime(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ format_dateNotime(item.LAST_DATE) }}
                        </template>
                        <template v-slot:[`item.endDate`]="{ item }">
                          <!-- <v-chip
                            :color="color"
                            dark
                        > -->
                          {{ format_dateNotime(item.endDate) }}
                          <!-- </v-chip> -->
                        </template>
                        <template v-slot:[`item.linePicture`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.linePicture" alt="img"
                          /></v-avatar>
                        </template>
                        <template v-slot:[`item.CHKDATE`]="{ item }">
                          <v-chip :color="getColor(item.CHKDATE)" dark>
                            {{ item.CHKDATE }}
                          </v-chip>
                        </template>
                      </v-data-table></v-card-text
                    >
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col class=" text-right">
                      <v-btn class="export-btn" dark color="green">
                        <v-icon left>mdi-download</v-icon>
                        <download-excel
                          class="btn btn-default text-white"
                          :data="export_data"
                          :fields="export_field"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileName"
                          :stringify-long-num="true"
                        >
                          Export Data
                        </download-excel>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-card flat>
                    <v-card-text>
                      <v-row class="mb-4">
                        <v-col cols="12" md="5">
                          <v-select
                            v-model="selectedProduct"
                            :items="productList"
                                      item-text="name"
                            item-value="rewardId"
                            label="สินค้าที่แลก"
                            clearable
                            outlined
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-menu
                            v-model="dateMenu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            hide-details
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="receiveDateRange2"
                                label="วันที่รับของรางวัล (ช่วงเวลา)"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                clearable
                                @click:clear="clearDateFilter2"
                                v-bind="attrs"
                                v-on="on"
                                 hide-details
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="receiveDate2"
                              range
                              @input="formatDateRange2"
                              @change="dateMenu2 = false"
                               hide-details
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="2" class="d-flex align-center">
                          <v-btn
                            color="primary"
                            block
                            @click="filterData2"
                          >
                            <v-icon left>mdi-magnify</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="columns2"
                        :items="filteredDataItem2"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.point`]="{ item }">
                          {{ formatNumber(item.point) }}
                        </template>
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ format_dateNotime(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.useDate`]="{ item }">
                          {{ format_dateNotime(item.useDate) }}
                        </template>
                        <template v-slot:[`item.endDate`]="{ item }">
                          <!-- <v-chip
                            :color="color"
                            dark
                        > -->
                          {{ format_dateNotime(item.endDate) }}
                          <!-- </v-chip> -->
                        </template>
                        <template v-slot:[`item.linePicture`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.linePicture" alt="img"
                          /></v-avatar>
                        </template> </v-data-table
                    ></v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
        <!-- end data table -->
      </div>
    </v-main>
  </div>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    moment,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {},
  data () {
    return {
      PK: '',
      path: '/rewardCode/', // Path Model
      // path2: '/ReportQRCode/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงานแลกของรางวัล',
          disabled: false,
          href: '/Tool/ReportCode'
        }
      ],

      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      searchAll2: '',

      // Data Table Config
      tab: null,
      columns1: [
        { text: 'รูปโปรไฟล์', value: 'linePicture' },
        { text: 'ชื่อ', value: 'lineName' },
        { text: 'สินค้าที่แลก', value: 'name' },
        { text: 'การรับสินค้า', value: 'supply' },
        { text: 'คะแนนที่แลก', value: 'point' },
        // { text: 'วันที่ทำเรื่อง', value: 'LAST_DATE' },
        { text: 'วันหมดอายุ', value: 'endDate' },
        { text: 'สถานะหมดอายุ', value: 'CHKDATE' }
      ],
      dataItem1: [],
      filteredDataItem1: [],
      selectedProduct: null,
      productList: [],
      expiryDate1: [],
      expiryDateRange1: '',
      dateMenu1: false,
      columns2: [
        { text: 'รูปโปรไฟล์', value: 'linePicture' },
        { text: 'ชื่อ', value: 'lineName' },
        { text: 'สินค้าที่แลก', value: 'name' },
        { text: 'คะแนนที่แลก', value: 'point' },
        { text: 'การรับสินค้า', value: 'supply' },
        { text: 'วันที่รับสิ้นค้า', value: 'useDate' }
        // { text: 'วันที่ทำเรื่อง', value: 'LAST_DATE' },
        // { text: 'วันหมดอายุ', value: 'endDate' },
        // { text: 'หมดอายุ', value: 'CHKDATE' }
      ],
      dataItem2: [],
      filteredDataItem2: [],
      selectedProduct: null,
      productList: [],
      receiveDate2: [],
      receiveDateRange2: '',
      dateMenu2: false,
      exportType: 'xls',
      exportFileName: 'รับของรางวัล.xls',
      exportFile: 'รายชื่อผู้ใช้ที่จะถูกตัดคะแนนประจำเดือน.xls',
      exportWorksheet: 'WorkSheet',
      export_field: {
        ชื่อ: 'lineName',
        'Reward Code': 'rewardCodeId',
        สินค้าที่แลก: 'name',
        จำนวนเหรียญที่แลก: 'point',
        การรับสินค้า: 'supply',
        วันที่รับสิ้นค้า: 'useDate'
      },
      export_data: null
      // End Data Table Config
    }
  },
  async mounted () {
    this.dataReady = false
    
    // Set default dates to today for both tabs
    const today = moment().format('YYYY-MM-DD')
    this.expiryDate1 = [today]
    this.expiryDateRange1 = moment(today).format('DD/MM/YYYY')
    this.receiveDate2 = [today]
    this.receiveDateRange2 = moment(today).format('DD/MM/YYYY')
    
    await Promise.all([
      this.getproductList(),
      this.getDataItem1(),
      this.getDataItem2()
    ])
    
    this.getColor()

  },
  methods: {
    async getproductList () {
      try {
        let url = this.DNS_IP +
          '/rewardCode/products/get?shopId=' +
          this.session.data.shopId 
        
        const response = await axios.get(url, { timeout: 5000 })
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          this.productList = response.data
          if (this.productList.length > 0 && !this.selectedProduct) {
            this.selectedProduct = this.productList[0].rewardId
          }
          console.log('Loaded', this.productList.length, 'products from API')
        } else {
          this.productList = []
          this.selectedProduct = null
          console.log('No products from API, will extract from data')
        }
      } catch (error) {
        console.log('Error fetching product list:', error)
        // Fallback: Extract from loaded data
        if (this.dataItem1.length > 0) {
          const uniqueProducts = []
          const seen = new Set()
          this.dataItem1.forEach(item => {
            if (item.rewardId && item.name && !seen.has(item.rewardId)) {
              seen.add(item.rewardId)
              uniqueProducts.push({ rewardId: item.rewardId, name: item.name })
            }
          })
          this.productList = uniqueProducts
          if (this.productList.length > 0) {
            this.selectedProduct = this.productList[0].rewardId
          }
          console.log('Extracted', this.productList.length, 'products from data')
        }
      }
    },

    async getDataItem1 () {
      this.dataItem1 = []
      
      // Build URL with filters
      let url = this.DNS_IP +
        '/rewardCode/get?redeemStatus=get&shopId=' +
        this.session.data.shopId
      
      // Add date range filter
      if (this.expiryDate1 && this.expiryDate1.length > 0) {
        const dates = [...this.expiryDate1].sort()
        const startDate = dates[0]
        const endDate = dates.length > 1 ? dates[1] : dates[0]
        url += `&startDate=${startDate}&endDate=${endDate}`
      }
      
      // Add product rewardId filter
      if (this.selectedProduct) {
        url += `&rewardId=${this.selectedProduct}`
      }
      
      await axios
        .get(url)
        .then(async response => {
          console.log('getData1', response.data)
          this.dataReady = true
          
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            this.dataItem1 = response.data
            this.filteredDataItem1 = response.data
            this.dataItem1.map(el => {
              this.getColor(this.format_dateNotime(el.endDate))
            })
            // Fallback: Extract unique products if API didn't provide them
            if (this.productList.length === 0) {
              const uniqueProducts = []
              const seen = new Set()
              response.data.forEach(item => {
                if (item.rewardId && item.name && !seen.has(item.rewardId)) {
                  seen.add(item.rewardId)
                  uniqueProducts.push({ rewardId: item.rewardId, name: item.name })
                }
              })
              this.productList = uniqueProducts
              console.log('Extracted', this.productList.length, 'products from data')
            }
          } else {
            this.dataItem1 = []
            this.filteredDataItem1 = []
          }
        })
      // eslint-disable-next-line handle-callback-err
      // .catch(error => {
      //   console.log(error)
      //   this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
      //   this.dataReady = true
      // })
    },
    getColor (CHKDATE) {
      if (CHKDATE === 'หมดอายุ') return 'red'
      else return 'green'
    },
    async getDataItem2 () {
      // Clear Data ทุกครั้ง
      this.dataItem2 = []
      
      // Build URL with filters
      let url = this.DNS_IP +
        '/rewardCode/DESC/get?redeemStatus=use&shopId=' +
        this.session.data.shopId
      
      // Add date range filter
      if (this.receiveDate2 && this.receiveDate2.length > 0) {
        const dates = [...this.receiveDate2].sort()
        const startDate = dates[0]
        const endDate = dates.length > 1 ? dates[1] : dates[0]
        url += `&startDate=${startDate}&endDate=${endDate}`
      }
      
      // Add product rewardId filter
      if (this.selectedProduct) {
        url += `&rewardId=${this.selectedProduct}`
      }
      
      await axios
        .get(url)
        .then(async response => {
          console.log('getData22', response.data)
          this.dataReady = true
          
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            this.dataItem2 = response.data
            this.filteredDataItem2 = response.data
            this.export_data = response.data
            // Fallback: Extract unique products if API didn't provide them
            if (this.productList.length === 0) {
              const uniqueProducts = []
              const seen = new Set()
              response.data.forEach(item => {
                if (item.rewardId && item.name && !seen.has(item.rewardId)) {
                  seen.add(item.rewardId)
                  uniqueProducts.push({ rewardId: item.rewardId, name: item.name })
                }
              })
              this.productList = uniqueProducts
              console.log('Extracted', this.productList.length, 'products from data')
            }
          } else {
            this.dataItem2 = []
            this.filteredDataItem2 = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    formatDateRange1 () {
      if (this.expiryDate1 && this.expiryDate1.length > 0) {
        const dates = [...this.expiryDate1].sort()
        const startDate = dates[0]
        const endDate = dates.length > 1 ? dates[1] : dates[0]
        this.expiryDateRange1 = moment(startDate).format('DD/MM/YYYY') + 
                                (dates.length > 1 ? ' - ' + moment(endDate).format('DD/MM/YYYY') : '')
      }
    },
    async filterData1 () {
      await this.getDataItem1()
    },
    clearDateFilter1 () {
      this.expiryDate1 = []
      this.expiryDateRange1 = ''
    },
    formatDateRange2 () {
      if (this.receiveDate2 && this.receiveDate2.length > 0) {
        const dates = [...this.receiveDate2].sort()
        const startDate = dates[0]
        const endDate = dates.length > 1 ? dates[1] : dates[0]
        this.receiveDateRange2 = moment(startDate).format('DD/MM/YYYY') + 
                                 (dates.length > 1 ? ' - ' + moment(endDate).format('DD/MM/YYYY') : '')
      }
    },
    async filterData2 () {
      // Reload data from API with filters
      await this.getDataItem2()
    },
    clearDateFilter2 () {
      this.receiveDate2 = []
      this.receiveDateRange2 = ''
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/ReportCode.vue